import { LOCAL_STORAGE_USER_DATA } from 'constants.js';
import { getRegion } from 'utils/Region';
import Utils from 'utils/Utils';

const DEVICE = 'web';

export const getNewEventDefaults = () => {
  const loginInfo = localStorage.getItem(LOCAL_STORAGE_USER_DATA);
  const parsed = JSON.parse(loginInfo || '{}');
  const countryCode = Utils.getAbbreviation(getRegion());

  if (!parsed.user_id || !countryCode) return {};

  const newEventDefaults = {
    user_id: parsed.user_id,
    parent_id: parsed.parent_id,
    country: countryCode,
    device: DEVICE,
  };

  return newEventDefaults;
};